import {colors} from '@/constants'

export const SUBJECT_MAX = 120
export const MESSAGE_MAX = 2000

export const inputSx = {
  '& .MuiOutlinedInput-root': {
    color: colors.white,
    background: colors.brown2 + '40',
    borderRadius: '10px',
    '& fieldset': {borderColor: colors.lightBrown + '40'},
    '&:hover fieldset': {borderColor: colors.lightBrown},
    '&.Mui-focused fieldset': {borderColor: colors.yellow},
  },
  '& .MuiOutlinedInput-input::placeholder': {
    color: colors.gray,
    opacity: 1,
  },
}
